import axios from 'core/network/interceptor';
import { DeleteAgentUrl, GetAgentsUrl, GetAgentUrl, PostAgentUrl, PutAgentUrl } from './constants';

interface createAgentEntryVariables {
    data: any;
}

const CreateAgentRequest = async ({data}: createAgentEntryVariables) => {
    const response = await axios.post(PostAgentUrl, data);

    return response.data.agent;
};

const GetAgentRequest = async (agentId: number) => {
    const response = await axios.get(GetAgentUrl(agentId));

    return response.data.agent;
};

const DeleteAgentRequest = async (agentId: number) => {
    const response = await axios.delete(DeleteAgentUrl(agentId));

    return response.data;
};

const GetAgentsRequest = async () => {
    const response = await axios.get(GetAgentsUrl);

    return response.data.agents;
};

interface updateAgentEntryVariables {
    id: number;
    data: any;
}

const UpdateAgentRequest = async ({id, data}: updateAgentEntryVariables) => {
    const response = await axios.put(PutAgentUrl(id), data);

    return response.data.agent;
};

export { CreateAgentRequest, GetAgentRequest, DeleteAgentRequest, GetAgentsRequest, UpdateAgentRequest };